<a [href]="getUrl()" target="_blank" class="property-card">
  <div class="property-card-image">
    <img src="{{details?.mainPhoto}}"
         alt="" class="card-image w-100"
         yp-e2e-id="similar-property-image"/>
  </div>
  <div class="property-card-description">
    <div class="property-card-description-price">
      <span class="property-price"
            yp-e2e-id="similar-property-price">{{details?.price | gbpCurrency}}</span>
      <span [innerHTML]="details?.priceQualifier?.id | priceQualifier : true"
            class="property-status"
            yp-e2e-id="similar-property-price-qualifier"></span>
    </div>
    <span class="property-card-description-heading"
          yp-e2e-id="similar-property-address">{{details?.fullAddress}}</span>
    <span class="property-card-description-type"
          yp-e2e-id="similar-property-type">
      <span *ngIf="!isLandProperty()">{{details?.bedrooms}} bedroom</span>
      {{details?.propertyType | propertyType}}
    </span>
  </div>
</a>
